import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AbilityService } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { ModalService } from 'mbs-ui-kit/modal/modal.service';
import { AdministratorsFacade } from 'mbs-ui-shared@facades/administrators.facade';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { LicensesFacade } from 'mbs-ui-shared@facades/licenses.facade';
import { LicenseType } from 'mbs-ui-shared@models';
import { FilterLicenseAndAdminId } from 'mbs-ui-shared@models/License';
import { AssignLicenseDialogueComponent } from 'mbs-ui-shared@modules/rmm-licenses/components/assign-license-dialogue/assign-license-dialogue.component';
import { LicensesService } from 'mbs-ui-shared@services/licenses.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LicensesPrepaymentFacade extends LicensesFacade {
  constructor(
    protected licensesService: LicensesService,
    protected modal: ModalService,
    protected i18nPipe: I18NextPipe,
    protected auth: AuthFacade,
    protected adminFacade: AdministratorsFacade,
    protected router: Router,
    protected ability: AbilityService,
    protected store: Store
  ) {
    super(licensesService, modal, i18nPipe, auth, adminFacade, router, ability, store);
  }

  public openAdminLicenseModal(data: FilterLicenseAndAdminId): Observable<boolean> {
    return this.openGrantLicenseDialogue(data.adminID, data.filter, this.isTrialLicenseAvailable(), false, data.email);
  }

  public openGrantLicenseDialogue(
    adminId: string,
    filter: LicenseType[] = null,
    withTrials = false,
    defaultFilter = true,
    email = ''
  ): Observable<boolean> {
    return super.openGrantLicenseDialogue(adminId, filter, withTrials, defaultFilter, email, AssignLicenseDialogueComponent);
  }

  public openGrantLicenseDialogueWithInfoModal(data: FilterLicenseAndAdminId) {
    return super.openGrantLicenseDialogueWithInfoModal(data, this.i18nPipe.transform('shared:licenses.actions.grant'));
  }
}
